var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50024 11.3334C8.96723 11.7483 8.26707 12 7.50024 12C6.73342 12 6.03326 11.7483 5.50024 11.3334",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06776 8.80901C0.83241 7.27753 0.714737 6.5118 1.00427 5.83296C1.29381 5.15412 1.93618 4.68966 3.22092 3.76075L4.18082 3.06671C5.77902 1.91115 6.57812 1.33337 7.50016 1.33337C8.4222 1.33337 9.2213 1.91115 10.8195 3.06671L11.7794 3.76075C13.0641 4.68966 13.7065 5.15412 13.9961 5.83296C14.2856 6.5118 14.1679 7.27753 13.9326 8.80901L13.7319 10.115C13.3982 12.286 13.2314 13.3715 12.4528 14.0191C11.6742 14.6667 10.5359 14.6667 8.25937 14.6667H6.74095C4.46438 14.6667 3.3261 14.6667 2.5475 14.0191C1.76889 13.3715 1.60208 12.286 1.26845 10.115L1.06776 8.80901Z",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSmall);
export default __webpack_public_path__ + "static/media/homeSmall.04d63ae16c379bd3afb40a3058ab9f79.svg";
export { ForwardRef as ReactComponent };